import { autoinject } from "aurelia-dependency-injection";

import { IGetCurrentUserDetailsResult, IGetCurrentUserResult } from "../interfaces/i-user";
import { AuthService } from "./auth-service";
import { UsersService } from "./users-service";
import { Moment } from "moment";
import moment from "moment";

@autoinject
export class CurrentUserService {
    private readonly _userService: UsersService;
    private readonly _authService: AuthService;
    private _currentUser: IGetCurrentUserResult = null;
    private _currentUserDetails: IGetCurrentUserDetailsResult = null;
    private _accountId: string;
    private _userExpirationTime: Moment = null;
    private _userDetailsExpirationTime: Moment = null;
    private _interval: NodeJS.Timeout;

    // Since CurrentUserService is used in AppNavbar it is always in scope, and thus can do it's own "global" intervel tracker
    // Users are considered stale after 10 minutes, so with a 5 minute interval check, we get the desired worst case staleness of 15 minutes
    private startStalenessTimer() {
        this._interval = setInterval(async () => {
            console.log("Checking User Staleness");
            if (this._currentUser !== null && moment().isAfter(this._userExpirationTime)) {
                this._currentUser = null;
                console.log("Stored User data is stale. Removing.");
            }
            if (this._currentUserDetails !== null && moment().isAfter(this._userDetailsExpirationTime)) {
                this._currentUserDetails = null;
                console.log("Stored UserDetails data is stale. Removing.");
            }
        }, 300000);
    }

    public constructor(userService: UsersService, authService: AuthService) {
        this._userService = userService;
        this._authService = authService;
        this.startStalenessTimer();
    }

    public async getUser() {
        let isLoggedIn = await this._authService.isLoggedIn();
        if (!isLoggedIn) {
            return null;
        }

        if (this._currentUser == null) {
            this._currentUser = await this._userService.getCurrentUser();
            this._userExpirationTime = moment().add(10, "m");
            console.log("Storing User data.");
        }

        return this._currentUser;
    }

    public async getUserDetails() {
        let isLoggedIn = await this._authService.isLoggedIn();
        if (!isLoggedIn || this._authService.needsAccountSelection()) {
            return null;
        }

        let currentAccountId = this._authService.getAccountId();
        if (this._currentUserDetails == null || currentAccountId !== this._accountId) {
            this._accountId = currentAccountId;
            this._currentUserDetails = await this._userService.getCurrentUserDetails();
            // Also update the lightweight version
            this._currentUser = this._currentUserDetails;
            this._userExpirationTime = moment().add(10, "m");
            this._userDetailsExpirationTime = moment().add(10, "m");
            console.log("Storing User data.");
            console.log("Storing UserDetails data.");
        }

        return this._currentUserDetails;
    }

    public clearUserCache() {
        this._currentUser = null;
        this._currentUserDetails = null;
    }

    public detached() {
        clearInterval(this._interval);
    }
}
